import { useContext } from "react";
import { MediaLibraryContext } from "./context";

export const useMediaLibraryContext = () => {
    const context = useContext(MediaLibraryContext);
    if (!context) {
        throw new Error("useMediaLibraryContext must be used within a MediaLibraryContextProvider");
    }
    return context;
};
